import { AlgoliaHitImageData } from '@repo/algolia/types'
import { imageQuality } from '@repo/sanity/image'
import { cn } from '@repo/ui/lib/utils'
import { Image } from 'next-sanity/image'
import { FunctionComponent } from 'react'

interface Props {
  image: AlgoliaHitImageData | undefined
  fallbackAlt?: string
  className?: string
  priority?: boolean
  sizes?: string
}

const AlgoliaHitImage: FunctionComponent<Props> = ({ image, fallbackAlt, className, priority = false, sizes = undefined }) => {
  if (!image) {
    return null
  }

  return (
    <Image
      fill={true}
      sizes={sizes}
      priority={priority}
      quality={imageQuality}
      className={cn('object-cover', className)}
      src={image.asset.url}
      alt={image.alt || fallbackAlt || ''}
      blurDataURL={image?.asset?.metadata?.lqip ?? undefined}
      placeholder={image?.asset?.metadata?.lqip ? 'blur' : undefined}
    />
  )
}

export default AlgoliaHitImage
